import type { AppConfig } from '../types/app-config.types';
import type { AppConfigSource } from '../types/app-config-source.types';
import { mapRawConfigToAppConfig } from '../utils/map-raw-config-to-app-config.util';

type RuntimeImportMeta = {
	env?: Record<string, unknown>;
};

export class ViteEnvAdapter implements AppConfigSource {
	public read(): AppConfig {
		const runtimeImportMeta = import.meta as unknown as RuntimeImportMeta;

		return mapRawConfigToAppConfig(runtimeImportMeta.env ?? {});
	}
}
